import { z } from 'zod';

export const streamerSchema = z.object({
  streamerId: z.string().min(1),
  displayName: z.string().min(1),
  avatar: z.string().min(1),
  brandColor: z.string().min(1),
  status: z.enum(['LIVE', 'AWAY', 'OFFLINE']),
  sampleBets: z.array(z.object({
    amount: z.number().positive(),
    currency: z.string().min(1),
    autoCashout: z.number().positive().optional(),
  })).min(1),
  streamerRecentMessages: z.array(z.object({
    id: z.string().min(1),
    text: z.string().min(1),
    at: z.string().min(1),
  })),
  roomStats: z.object({
    playersInRoom: z.number().nonnegative(),
    avgBet: z.number().nonnegative(),
    topWinners: z.array(z.object({
      name: z.string().min(1),
      win: z.number().nonnegative(),
    })),
    userRank: z.number().nonnegative().optional(),
  }),
  hypeThresholds: z.array(z.object({
    players: z.number().nonnegative(),
    label: z.string().min(1),
    bonus: z.string().min(1),
  })),
  promos: z.array(z.object({
    code: z.string().min(1),
    label: z.string().min(1),
    cta: z.string().min(1),
  })),
  specialEvents: z.array(z.object({
    id: z.string().min(1),
    label: z.string().min(1),
    type: z.string().min(1),
  })),
  slogan: z.string().optional(),
});

export type StreamerData = z.infer<typeof streamerSchema>;
